import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col border-b border-gray-100 last:border-0" }
const _hoisted_2 = { class: "text-md font-bold" }
const _hoisted_3 = {
  key: 0,
  class: "mr-3"
}
const _hoisted_4 = {
  key: 0,
  class: "bg-gray-50 rounded-b-lg mb-2 border-t border-gray-100"
}
const _hoisted_5 = { class: "flex flex-col text-left" }
const _hoisted_6 = { class: "text-gray-500 text-xs font-medium mb-0.5" }
const _hoisted_7 = { class: "text-primary font-medium text-[13px] leading-tight" }
const _hoisted_8 = { class: "flex items-center gap-2" }
const _hoisted_9 = { class: "bg-gray-100 px-3 py-1.5 rounded border border-gray-300 text-gray-600 text-xs font-semibold shadow-sm min-w-[160px] text-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "block text-[10px] font-normal text-gray-400 mt-0.5" }, "(Herdado)", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "w-[36px]" }, null, -1)

import { mdiChevronDown, mdiRefresh, mdiTrashCanOutline } from '@mdi/js'
import { AuthorizationResourcesAndSubjects, AuthorizationRelations } from '@/types/authorization'
import type { AuthorizationRelationResponseExpanded } from '@/Network/Types/Responses/AuthorizationResponses'

interface RoleTagInfo {
  label: string
  borderColor: string
  bgColor: string
  textColor: string
}

export interface SortedPermItem {
  resource_type: string
  resource_id: number
  resource_relation: string
  resource_name?: string
  is_current_context: boolean
  is_inherited: boolean
}

export interface SelectablePermission {
  label: string
  value: string
  disabled?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PermissionsAccordionItem',
  props: {
    subject: {},
    isExpanded: { type: Boolean },
    isMarkedForRemoval: { type: Boolean },
    canEditAccessLevel: { type: Boolean },
    selectablePermissions: {},
    sortedPermissions: {},
    getRelationLabel: { type: Function },
    resolveResourceName: { type: Function },
    pendingRelation: {}
  },
  emits: ["toggle", "change-relation", "toggle-removal"],
  setup(__props: any, { emit }) {

const ROLE_TAG_MAP: Record<string, RoleTagInfo> = {
  [AuthorizationRelations.Operator]: {
    label: 'Adm',
    borderColor: '#2F7F91',
    bgColor: '#D8EEF3',
    textColor: '#2F7F91'
  },
  [AuthorizationRelations.MedicalCoordinator]: {
    label: 'Med',
    borderColor: '#198038',
    bgColor: '#EAFBEF',
    textColor: '#198038'
  },
  [AuthorizationRelations.AuditAnalyst]: {
    label: 'Adm',
    borderColor: '#2F7F91',
    bgColor: '#D8EEF3',
    textColor: '#2F7F91'
  }
}

const getRoleTag = (relation: string): RoleTagInfo | null => {
  return ROLE_TAG_MAP[relation] || null
}





const getInitials = (name: string) => (name ? name.substring(0, 2).toUpperCase() : '')

const translateResourceType = (type: string) => {
  const map: Record<string, string> = {
    [AuthorizationResourcesAndSubjects.Company]: 'Empresa',
    [AuthorizationResourcesAndSubjects.HealthUnit]: 'Unidade',
    [AuthorizationResourcesAndSubjects.Schedule]: 'Escala',
    [AuthorizationResourcesAndSubjects.DsAttendanceCompany]: 'Empresa',
    [AuthorizationResourcesAndSubjects.DsAttendanceHealthUnit]: 'Unidade',
    [AuthorizationResourcesAndSubjects.DsAttendance]: 'Escala',
    [AuthorizationResourcesAndSubjects.StationExceptionalitiesCompany]: 'Empresa',
    [AuthorizationResourcesAndSubjects.StationExceptionalitiesHealthUnit]: 'Unidade',
    [AuthorizationResourcesAndSubjects.StationExceptionalitiesSchedule]: 'Escala',
    [AuthorizationResourcesAndSubjects.NpsCompany]: 'Empresa',
    [AuthorizationResourcesAndSubjects.NpsHealthUnit]: 'Unidade',
    [AuthorizationResourcesAndSubjects.PostStationCompany]: 'Empresa',
    [AuthorizationResourcesAndSubjects.PostStationHealthUnit]: 'Unidade'
  }
  return map[type] || type
}

return (_ctx: any,_cache: any) => {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_list_item, {
      class: _normalizeClass(["pl-0 h-[60px]", { 'opacity-50 grayscale pointer-events-none-children': _ctx.isMarkedForRemoval }]),
      color: "primary20",
      title: _ctx.subject.subject_name,
      subtitle: _ctx.subject.subject_description,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('toggle')))
    }, {
      prepend: _withCtx(() => [
        _createVNode(_component_v_avatar, { color: "primary30" }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_2, _toDisplayString(getInitials(_ctx.subject.subject_name)), 1)
          ]),
          _: 1
        })
      ]),
      append: _withCtx(() => [
        (_ctx.subject.effective_relation)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_v_chip, {
                size: "small",
                color: "primary",
                variant: "tonal",
                class: "font-weight-medium"
              }, {
                default: _withCtx(() => [
                  (getRoleTag(_ctx.subject.effective_relation))
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "text-[11px] px-1.5 py-0.5 rounded mr-1.5",
                        style: _normalizeStyle({
                border: `1px solid ${getRoleTag(_ctx.subject.effective_relation)!.borderColor}`,
                background: getRoleTag(_ctx.subject.effective_relation)!.bgColor,
                color: getRoleTag(_ctx.subject.effective_relation)!.textColor
              })
                      }, _toDisplayString(getRoleTag(_ctx.subject.effective_relation)!.label), 5))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.getRelationLabel(_ctx.subject.effective_relation)), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_v_btn, {
          icon: "",
          variant: "text",
          density: "compact"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, {
              icon: _unref(mdiChevronDown),
              class: _normalizeClass([{ 'rotate-180': _ctx.isExpanded }, "transition-transform duration-200"])
            }, null, 8, ["icon", "class"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["class", "title", "subtitle"]),
    _createVNode(_component_v_expand_transition, null, {
      default: _withCtx(() => [
        (_ctx.isExpanded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedPermissions, (permItem, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: _normalizeClass(["px-4 py-3 flex items-center justify-between text-sm hover:bg-gray-100 transition-colors border-b border-gray-200 last:border-0", { 'bg-white': permItem.is_current_context }])
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(translateResourceType(permItem.resource_type)) + ": ", 1),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.resolveResourceName(permItem)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    (permItem.is_current_context)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_v_select, {
                            "model-value": _ctx.pendingRelation ?? _ctx.subject.resource_relation,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (emit('change-relation', $event))),
                            disabled: !_ctx.canEditAccessLevel || _ctx.isMarkedForRemoval,
                            items: _ctx.selectablePermissions,
                            "item-title": "label",
                            "item-value": "value",
                            "item-props": "",
                            color: "primary20",
                            density: "compact",
                            variant: "outlined",
                            "hide-details": "",
                            class: "min-w-[160px] permission-select-dense bg-white"
                          }, null, 8, ["model-value", "disabled", "items"]),
                          (_ctx.canEditAccessLevel && _ctx.subject.resource_relation)
                            ? (_openBlock(), _createBlock(_component_v_btn, {
                                key: 0,
                                icon: "",
                                variant: "text",
                                density: "comfortable",
                                color: _ctx.isMarkedForRemoval ? 'primary' : 'red-lighten-1',
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('toggle-removal'))),
                                class: "ml-1"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    icon: _ctx.isMarkedForRemoval ? _unref(mdiRefresh) : _unref(mdiTrashCanOutline),
                                    size: "small"
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              }, 8, ["color"]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("div", _hoisted_9, [
                            (getRoleTag(permItem.resource_relation))
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: "text-[10px] font-semibold px-1 py-0.5 rounded mr-1 inline-block",
                                  style: _normalizeStyle({
                    border: `1px solid ${getRoleTag(permItem.resource_relation)!.borderColor}`,
                    background: getRoleTag(permItem.resource_relation)!.bgColor,
                    color: getRoleTag(permItem.resource_relation)!.textColor
                  })
                                }, _toDisplayString(getRoleTag(permItem.resource_relation)!.label), 5))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(_ctx.getRelationLabel(permItem.resource_relation)) + " ", 1),
                            _hoisted_10
                          ]),
                          _hoisted_11
                        ], 64))
                  ])
                ], 2))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})